const getters = {
  getSnackbar: (state) => state.snackbar,
  getModal: (state) => state.modal,
  getPageInfo: (state) => state.pageInfo,
  getProfileMenu: (state) => state.profileMenu,
  getItemListingOrganisation: (state) => state.itemListingOrganisation,
  getUploadProgress: (state) => state.uploadProgress,
  getRouteViewKey: (state) => state.routeViewKey,
  getPageLoadingFirstTime: (state) => state.pageLoadingFirstTime,
  getRouteOnChanged: (state) => state.routeOnChanged,
};

export default getters;
